import { StateServices } from './../../../../services/state.services'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { SharedServices } from '../../../../services/shared.services'
import { Router } from '@angular/router'
import { AuthService } from '../../../../services/auth.services'
import { RestServices } from '../../../../services/rest.services'
import { ModalService } from '../../../../services/modal.service'
import * as moment from 'moment'
import { MatrixServices } from '../../../../services/image/matrix.services'
import { imageUrl } from '../../../../../helper/common'

@Component({
    selector: 'app-newroom',
    templateUrl: './newroom.component.html',
    styleUrls: [
        '../../../../stagingcss/main-body.component.css',
        '../../../../stagingcss/root-ui-view.component.css',
        './newroom.component.css',
        '../../../../stagingcss/lui-select.component.css'],
})
export class NewroomComponent implements OnInit, OnDestroy {
    listCheckOwner
    listCheckOwnerId
    listCheckarrUsers
    listCheckarrUsersId
    explanation
    title
    url
    faceImage
    arrFace
    statusImage = false
    createDate
    showDate1
    timestampDate
    arrData = {}
    arrImage = []
    arrImageHash = []
    matrixImage = []
    animationDuration
    arrLoading = false
    statusShowImage = false
    roomTags = []
    selectedTags = []

    enableBehavior: any = 'false'
    unscrSave
    unscrIsSave
    isSaveNewRoom = false

    constructor(private authData: AuthService, private stateServices: StateServices, private router: Router, private restApi: RestServices, private _sharedService: SharedServices, private modalService: ModalService, public matrixServices: MatrixServices) {
        this.unscrSave = _sharedService.changeEmittedSource$.subscribe(
            success => {
                if (success[2] === 'arrOwner') {
                    this.listCheckOwner = success[0]
                    this.listCheckOwnerId = success[1]
                    if (JSON.stringify(success[0]).length > 2) {
                        this._sharedService.emitChange('activeAlertNewRoom')
                    }
                }
                if (success[2] === 'arrUsers') {
                    this.listCheckarrUsers = success[0]
                    this.listCheckarrUsersId = success[1]
                    if (JSON.stringify(success[0]).length > 2) {
                        this._sharedService.emitChange('activeAlertNewRoom')
                    }
                }
            })
        this.unscrIsSave = this._sharedService.changeEmitted$.subscribe(
            success => {
                if (success === 'saveNewRoom') {
                    this.saveNewRoom('other')
                }
            },
        )
    }

    ngOnInit() {
        this.enableBehavior = this.stateServices.returnEnableBehavior()
        this.listCommunication()
        const jsonFlip: any = {}
        jsonFlip['horizontalFlip'] = 1
        jsonFlip['verticalFlip'] = 1
        const arrFlip: any[] = []
        arrFlip.push(jsonFlip)
        this.matrixServices.arrImageHash = [{}]
        this.matrixServices.arrRotate = [0]
        this.matrixServices.arrStyleImage = ['']
        this.matrixServices.arrFlip = arrFlip
        this.matrixServices.dXdYMatrixCanvas = [0]
        this.showDate1 = moment().format('YYYY.MM.DD ddd')
    }

    ngOnDestroy() {
        if(this.unscrSave)
            this.unscrSave.unsubscribe()
        if(this.unscrIsSave)
            this.unscrIsSave.unsubscribe()
    }

    listCommunication() {
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [],
            status: {
                clinic: {
                    paths: {
                        '{}': true,
                    },
                },
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
                room: {
                    searches: {
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(
                success => {
                    const user = success['user']
                    this.enableBehavior = this.stateServices.checkEnableSettingBehaviour(user['_id'])
                    const emitSakura = {}
                    emitSakura['enableBehavior'] = this.enableBehavior
                    this.stateServices.emitChangeEnableBehavior(emitSakura)
                    const settingBehavior: any[] = success['response']['setting']['paths']['{}'] ? success['response']['setting']['paths']['{}'] : []
                    const findItem = settingBehavior.find(el => {
                        return el['_id'] == 'option'
                    })
                    if (findItem) {
                        if (this.enableBehavior == 'true') {
                            this.roomTags = findItem['roomTag'] ? findItem['roomTag'] : []
                        } else {
                            this.roomTags = []
                        }
                    } else {
                        this.roomTags = []
                    }
                },
            )
        })
    }

    // add or remove selected tags
    toggleTag(item) {
        // this.markChanged();
        const found = this.selectedTags.findIndex((e) => {
            return e == item._id
        })
        if (found == -1) {
            this.selectedTags.push(item._id)
        } else {
            this.selectedTags.splice(found, 1)
        }
    }

    // check tag is selected
    checkActiveTag(item) {
        const found = this.selectedTags.findIndex((e) => {
            return e == item._id
        })
        if (found == -1) {
            return false
        }
        return true
    }

    onDistry() {
        if (this.title != undefined || this.faceImage != undefined || this.explanation != undefined) {
            if (this.authData.getItem('user')) {
                const user = JSON.parse(this.authData.getItem('user'));
                const expires = parseInt((user.expiresInSeconds)) * 1000;
                const timeOut = parseInt(this.authData.getItem('timeout')) + expires;
                const timeNow = Date.now();
                if(timeOut > timeNow){
                    this._sharedService.emitChange('activeAlertNewRoom')
                }
            }
        }
    }

    getOwner() {
        this._sharedService.emitChange('activeOwners')
        const arrOwners = ['activeOwnersNewRoom', this.listCheckOwnerId && this.listCheckOwnerId.length > 0 ? this.listCheckOwnerId : undefined, this.listCheckOwner]
        // console.log(arrOwners);
        this._sharedService.emitChange(arrOwners)
    }

    getUsers() {
        this._sharedService.emitChange('activeUsers')
        const arrUsers = ['activeUsersNewRoom', this.listCheckarrUsersId && this.listCheckarrUsersId.length > 0 ? this.listCheckarrUsersId : undefined, this.listCheckarrUsers]
        this._sharedService.emitChange(arrUsers)
    }

    allowDrop(e) {
        e.preventDefault()
    }

    drop(ev) {
        ev.preventDefault()
        const reader = new FileReader()
        reader.readAsDataURL(ev.dataTransfer.files[0])
        const excrptFile: any = 'image/'
        const tmpFile: any = ev.dataTransfer.files[0]
        const typeFile: String = tmpFile['type']
        this.animationDuration = 2800
        if (typeFile.includes(excrptFile) && ev.dataTransfer.files && ev.dataTransfer.files.length > 0) {
            reader.onload = (event: any) => { // called once readAsDataURL is completed
                // const json = JSON.stringify(event.target.result);
                // const blob = new Blob([json], {type: 'image/jpeg'});
                //     this.url = URL.createObjectURL(blob);
                // this.url = event.target.result;
                this.arrLoading = true
                this.statusImage = true
                this.statusShowImage = true
                this.arrImageHash = [undefined]
                this.matrixImage = [1, 0, 0, 1]
            }
            this.authData.authToken().then(tokenReNew => {
                this.restApi.postFile(ev.dataTransfer.files.item(0), tokenReNew).subscribe(
                    success => {
                        this.faceImage = success['hash']
                        const idImage = {
                            id: this.faceImage,
                            matrix: [1, 0, 0, 1],
                        }
                        this.matrixImage[0] = [1, 0, 0, 1]
                        // this.matrixServices.arrImageHash.splice(0, 1, idImage);
                        this.arrImageHash.splice(0, 1, idImage)
                        this.url = imageUrl + success['hash'] + '?type=medium'
                        this.arrImage.splice(0, 1, this.url)
                        this.arrLoading = false
                        this.statusShowImage = false
                    },
                )
            })
        }
    }

    handleFileInput(files: FileList, event) {
        if (event.target.files && event.target.files[0]) {
            const reader = new FileReader()
            this.isSaveNewRoom = true
            reader.readAsDataURL(event.target.files[0]) // read file as data url

            reader.onload = (event: any) => { // called once readAsDataURL is completed
                // const json = JSON.stringify(event.target.result);
                // const blob = new Blob([json], {type: 'image/jpeg'});
                //     this.url = URL.createObjectURL(blob);
                // this.url = event.target.result;
                this.arrLoading = true
                this.animationDuration = 2800
                this.statusImage = true
                this.statusShowImage = true
                this.arrImageHash = [undefined]
                this.matrixImage = [1, 0, 0, 1]
            }
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.postFile(files.item(0), tokenReNew).subscribe(
                success => {
                    this.faceImage = success['hash']
                    const idImage = {
                        id: this.faceImage,
                        matrix: [1, 0, 0, 1],
                    }
                    this.matrixImage[0] = [1, 0, 0, 1]
                    // this.matrixServices.arrImageHash.splice(0, 1, idImage);
                    this.arrImageHash.splice(0, 1, idImage)
                    this.url = imageUrl + success['hash'] + '?type=medium'
                    this.arrImage.splice(0, 1, this.url)
                    this.arrLoading = false
                    this.statusShowImage = false
                    this.isSaveNewRoom = false
                },
            )
        })
    }

    // show theme date
    showDate(event) {
        if (event) {
            const settimestamp = moment(event['_d'])
            settimestamp.set({ hours: 10 })
            const timestamp = moment(settimestamp).utc().startOf('day').valueOf()
            this.showDate1 = moment(timestamp).format('YYYY.MM.DD ddd')
            this.timestampDate = timestamp
        } else {
            this.showDate1 = moment().format('YYYY.MM.DD ddd')
            this.timestampDate = moment().utc().startOf('day').valueOf()
        }
    }

    nextDate(timestampAdd, day) {
        const adDate = moment(timestampAdd)
        const timestampDate = moment(adDate['_d']).add(day, 'days').utc().startOf('day').valueOf()
        const showdateAdd = moment(timestampDate).format('YYYY.MM.DD ddd')
        this.timestampDate = timestampDate
        this.showDate1 = showdateAdd
    }

    prevDate(timestampAdd, day) {
        const adDate = moment(timestampAdd)
        const timestampDate = moment(adDate['_d']).subtract(day, 'days').utc().startOf('day').valueOf()
        const showdateAdd = moment(timestampDate).format('YYYY.MM.DD ddd')
        this.timestampDate = timestampDate
        this.showDate1 = showdateAdd
    }

    saveNewRoom(option) {
        this.arrData['title'] = this.title
        this.arrData['explanation'] = this.explanation
        this.arrData['owners'] = this.listCheckOwnerId
        this.arrData['users'] = this.listCheckarrUsersId
        this.arrData['visitDate'] = this.timestampDate
        this.arrData['tags'] = this.selectedTags
        if (this.faceImage !== undefined) {
            this.arrData['faceImage'] = this.arrImageHash[0]
        }
        // console.log(this.arrImageHash[0]);
        const value = this.arrData
        const resourceData = {
            actions: [
                {
                    type: 'create',
                    id: null,
                    collection: 'room',
                    value,
                },
            ],
            status: {
                setting: {
                    map: {
                        common: true,
                    },
                    paths: {
                        '{}': true,
                    },
                },
                staff: {
                    paths: {
                        '{"roles":"cordinator"}': true,
                        '{"roles":"doctor"}': true,
                        '{}': true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post('resource', resourceData, tokenReNew).subscribe(
                success => {
                    this.modalService.emitChange('hiddenThenSaveMail')
                    this._sharedService.emitChange('discardNewRoom')
                    this.listCheckOwner = []
                    this.listCheckOwnerId = []
                    this.listCheckarrUsersId = []
                    this.listCheckarrUsers = []
                    if (option == 'save') {
                        this.router.navigateByUrl('/app/main/communication/room/' + success['response']['room']['updatedItem'] + '/home')
                    }
                },
            )
        })
    }

    removeImage() {
        this.matrixServices.arrStyleImage.splice(0, 1)
        this.matrixServices.arrFlip.splice(0, 1)
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/app_element/communication/newroom/newroom.component.ts